// next-app/src/lib/validations/profile.ts
import { z } from 'zod';
import {
  emailSchema,
  phoneSchema,
  address1Schema,
  citySchema,
  zipSchema,
  requiredSchema,
  optionalPasswordSchema,
  optionalStringSchema,
} from './validators';

// ============================================
// PROFILE FORM
// Reference: src/pages/Profile.tsx
// ============================================

export const profileSchema = z
  .object({
    dealer_name: requiredSchema.max(50),
    address: address1Schema,
    address2: optionalStringSchema,
    city: citySchema,
    state: requiredSchema,
    zip: zipSchema,
    phone: phoneSchema,
    primary_contact: requiredSchema.max(50),
    contact_phone: phoneSchema,
    contact_email: emailSchema,
    password: optionalPasswordSchema.optional().or(z.literal('')),
    confirm_password: z.string().optional().or(z.literal('')),
  })
  .refine(
    (data) => {
      // If password is provided, confirm must match
      if (data.password && data.password.length > 0) {
        return data.password === data.confirm_password;
      }
      return true;
    },
    {
      message: 'Passwords must match',
      path: ['confirm_password'],
    }
  );

export type ProfileFormData = z.infer<typeof profileSchema>;
